
// Define controllers.
window.nujwvf = {
	FormController
};

// Todo: This isn't really the way Alpine.js components are supposed to be built - I'm
// just trying to get all the script tags out of the views.
function FormController() {

	var host = this.$el;
	var movementKind = null;
	var selectAllLink = document.querySelector( ".select-all" );
	var checkboxes = host.querySelectorAll( "input[name='movementKind']" );
	var listItems = host.querySelectorAll( "li[data-is-push], li[data-is-pull], li[data-is-legs]" );

	for ( var node of checkboxes ) {

		node.addEventListener( "input", handleCheckbox );

	}

	// Handle any initial filtering.
	setMovementKind();
	updateListFiltering();

	function setMovementKind() {

		movementKind = null;

		for ( var node of checkboxes ) {

			if ( node.checked ) {

				movementKind = node.value;

			}

		}

	}

	function handleCheckbox( event ) {

		setMovementKind();
		updateListFiltering();
		updateSelectAll();

	}

	function updateListFiltering() {

		for ( var node of listItems ) {

			var isMatch = (
				( movementKind === "all" ) ||
				( ( movementKind === "push" ) && ( node.dataset.isPush === "yes" ) ) ||
				( ( movementKind === "pull" ) && ( node.dataset.isPull === "yes" ) ) ||
				( ( movementKind === "legs" ) && ( node.dataset.isLegs === "yes" ) )
			);

			node.hidden = ! isMatch;

		}

	}

	function updateSelectAll() {

		var url = new window.URL( selectAllLink.href );
		url.searchParams.set( "movementKind", movementKind );

		selectAllLink.href = url.toString();

	}

}
